import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { LoyaltyOverviewPage } from '../../../features/loyalty/overview-page'
import { overviewSearchSchema } from '../../../features/loyalty/search'

export const Route = createFileRoute('/_app/loyalty/')({
  staticData: { crumb: 'loyalty' },
  validateSearch: overviewSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'loyalty.read'),
  component: LoyaltyOverviewPage,
})
